import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { BrowserRouter as Router } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import ErrorBoundary from './ErrorBoundary';
import TopNavBar from './components/TopNavBar/TopNavBar';
import Footer from './components/Footer/Footer';
import Routes from './routes';
import './App.css';

class App extends Component {
  constructor(props) {
      super(props);
      autoBind(this);
  } 

  render () {
    return (
      <Router basename={process.env.PUBLIC_URL}>
        <span>
              <ErrorBoundary>
              <TopNavBar cookies={this.props.cookies} />
              <Routes cookies={this.props.cookies} />    
              <Footer />
            </ErrorBoundary>
        </span>
    </Router>
    );
  }
}

export default withCookies(App);